import { render, staticRenderFns } from "./BulkAssignTasksModal.vue?vue&type=template&id=715b6828&scoped=true"
import script from "./BulkAssignTasksModal.vue?vue&type=script&lang=js"
export * from "./BulkAssignTasksModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAssignTasksModal.vue?vue&type=style&index=0&id=715b6828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b6828",
  null
  
)

export default component.exports